// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__A9vY8","choiceBoxes":"toolbarselects_choiceBoxes__1m5JP","simpleField":"toolbarselects_simpleField__3MdPt"};